import { Box, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const GeneralDetailsStep = ({
  title,
  setTitle,
  description,
  setDescription,
  loading,
}) => {
  const { t } = useTranslation("assets");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <TextField
        label={t("editModal.titleLabel")}
        variant="outlined"
        fullWidth
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        disabled={loading}
        required
        error={!title.trim()}
        helperText={!title.trim() ? t("editModal.titleRequired") : ""}
      />

      <TextField
        label={t("editModal.descriptionLabel")}
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        disabled={loading}
        placeholder={t("editModal.descriptionPlaceholder")}
      />
    </Box>
  );
};

export default GeneralDetailsStep;
